import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/course-lessons', payload)
    return response || null
  },
  
  async update(payload) {
    let response = await api.put('/admin/course-lessons', payload)
    return response
  },

  async delete(payload) {
    const response = await api.delete('/admin/course-lessons', {
      data: payload,
    })
    return response
  },

  async getList(params) {
    let response = await api.get('/admin/course-lessons', {
      params,
    })
    return response.data.data
  },

  async get(params) {
    let response = await api.get('/admin/course-lessons/detail', {
      params,
    })
    return response.data.data.document || null
  },
  
}
